module.exports = __webpack_public_path__ + "img/defauthead.26a3aa63.png";